import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { WebhookEndpoint } from 'src/features/webhook-endpoints/utils/types';

const RESOURCE = '/webhooks/webhook-endpoints/:endpointId/rotate-secret/';

type MutationFnType = typeof mutationFn;
interface DTO {
    endpointId: string;
}

const mutationFn = ({ endpointId }: DTO): Promise<WebhookEndpoint> => {
    return axios.post(formatResourcePath(RESOURCE, { endpointId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useRotateWebhookEndpointSecret };
